import {useEffect, useState} from "react";
import {Redirect} from "react-router-dom";
import {getApplicationState, setApplicationState} from "../../services/common";
import {genRandomString} from "@okta/okta-auth-js";
import {getLinkedInAuthorizeUrl} from "../../services/api/socialIdentityApi";


const LinkedInRedirect = () => {
	const [completed, setCompleted] = useState(false);

	useEffect(() => {
		(async () => {
			try {
				const appState = getApplicationState();
				if(!('linkedin' in appState)) {
					appState.linkedin = {};
				}

				appState.linkedin.state = genRandomString(32);

				setApplicationState(appState);

				const response = await getLinkedInAuthorizeUrl(appState.linkedin.state);

				if (!response?.data?.data) {
					setCompleted(true);
					return;
				}

				window.location.href = response.data.data;
			}
			catch(_) {
				setCompleted(true);
			}
		})();
	}, []);

	if(completed) {
		return (<Redirect to={'/'} />);
	}

	return (<></>);
}

export default LinkedInRedirect;
